<template>
  <v-card flat class="market-table">
    <v-card-title class="market-table__title">
      Órdenes {{(orderType==='buy')?' de compra':' de venta'}} <span>{{ orders.length }} disponibles</span>
    </v-card-title>
    <v-data-table 
      :headers="headers"
      :items="orders"
    >
      <template v-slot:item.name="{ item }">
        <v-btn 
          @click="$router.push('projects/'+item.projectId)"
          text
        > 
          {{item.name}}
        </v-btn>
      </template>
      <template v-slot:item.projectReturnsSince="{ item }">
        {{printDate(item.creationDate,item.profitsBeginQuantity * item.profitsBeginTimePeriod)}}
      </template>
      <template v-slot:item.projectReturn="{ item }">
        % {{item.estimatedReturn*100}}
      </template>
      <template v-slot:item.actions="{ item }">
        <order-button :pj="item" orderType="buy" />
        <order-button :pj="item" orderType="sell" />
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
export default {
  props:{
    orders:{
      type:Array,
      default: ()=> {
        return []
      }
    },
    orderType:{
      type:String,
      default:'undefined'
    }
  },
  components:{
    OrderButton:()=>import('./OrderButton.vue')
  },
  data(){
    return {
      headers:[
        {text: 'Proyecto', value: 'name'},
        {text: 'Moneda', value: 'currency'},
        {text: 'Retorno' , value: 'projectReturn'},
        {text: 'Retorno desde ', value: 'projectReturnsSince'},
        {text: 'Punta de venta', value:'lowestSellingPrice'},
        {text: 'Punta de compra', value:'heighestBuyingPrice'},
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      on:undefined
      
    }
  },
  methods:{
    printDate(creationDate, days){
      let dateStr = new Date(creationDate)
      
      dateStr.setDate(dateStr.getDate() + days);
      return dateStr.toLocaleDateString()
    },
    placeBuyOrder(item){
      this.$store.commit('pushModal', 
      {
        type:'NewOrder', 
        params:
        { 
          projectInfo:
          {
            id:item.projectId,
            name:item.projectName,
            currency: item.currency,
            type:'buy',
            creditsAvailable: item.credits,
            orderId: item.orderId
          }
        }
      }) 
    },
    placeSellOrder(item){
      this.$store.commit('pushModal', 
      {
        type:'NewOrder', 
        params:
        { 
          projectInfo:
          {
            id:item.projectId,
            name:item.projectName,
            currency: item.currency,
            type:'sell',
            creditsAvailable: item.credits,
            orderId: item.orderId
          }
        }
      }) 
    },
    creditsProcessed(item){
      if(this.orderType ==="buy"){
        return item.credits - item.creditsTransactioned
      } else if(this.orderType ==="sell"){
        return item.creditsTransactioned
      }
    }
  }
}
</script>
<style scoped>
.market-table{border-radius:0!important;background:#fff!important}.market-table__title{font-family:Georgia,serif!important;font-size:27px!important;font-weight:400!important;color:#173347;padding:24px!important;border-bottom:1px solid #ebe7df}.market-table__title span{font-family:Inter,Arial,sans-serif;font-size:10px;color:#d5654c;text-transform:uppercase;letter-spacing:.8px;margin-left:12px}.market-table :deep(th){font-size:10px!important;text-transform:uppercase;letter-spacing:.7px;color:#71818a!important;font-weight:700!important}.market-table :deep(td){color:#405866;font-size:13px}.market-table :deep(.v-data-table__wrapper){border-radius:0}.market-table :deep(.v-btn){color:#173347!important;text-transform:none!important;font-weight:700;font-size:12px}
</style>
